import React, { useMemo } from "react";

import { Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import Space from "shared/components/Space";
import { NAME_SPACES } from "shared/locals/constants";
import { formatOpeninHours } from "utils/helpers/hours";
import { useInfo } from "utils/hooks/info";

import "./style.scss";

const Component = () => {
  const {
    info,
    commonInfo: { knownCustomer },
  } = useInfo();
  const { t } = useTranslation(NAME_SPACES.CONTACT_US);
  const LABEL = t("CONTACT_US", { returnObjects: true });
  const openingHours = useMemo(
    () => formatOpeninHours(info.openHours),
    [info.openHours],
  );

  return (
    <div className={"page-card"}>
      <div className="center">
        <AiOutlineQuestionCircle size={30} />
        <Space h={24} />
        <h4 className="Text">
          {knownCustomer ? LABEL.TITLE : LABEL.UNKNOWN_TITLE}
        </h4>

        <Space h={24} />
        {info?.phone && (
          <Row>
            <h4 className="Text">{LABEL.PHONE}</h4>
            <p className="openHour">{info.phone}</p>
          </Row>
        )}
        {info?.email && (
          <Row>
            <h4 className="Text">{LABEL.MAIL}</h4>
            <p className="openHour">{info.email}</p>
          </Row>
        )}
        {info?.address && (
          <>
            <Row>
              <h4 className="Text">{LABEL.ADDRESS}</h4>
            </Row>
            <Row>
              <p className="openHour">{info.address.street}</p>
            </Row>
            <Row>
              <p className="openHour">
                {info.address.postalCode} {info.address.city}
              </p>
            </Row>
            <Row>
              <p className="openHour">{info.address.country}</p>
            </Row>
          </>
        )}
        <Space h={24} />
        <div className="containerHourAndDays">
          <h4 className="Text">{LABEL.HORAIRES}</h4>
          <Space h={12} />

          {openingHours.map(({ day, openingTimes }) => (
            <div className="ContainerOpenHours" key={day}>
              <Row className="RowOpenHours">
                <Col className="days_column">{day}:</Col>
                <Col className="hours_column">{`${openingTimes}`}</Col>
              </Row>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Component;
